import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import PercentageDataPod from '../../../components/PercentageDataPod';

const messages = defineMessages({
  years1: {
    id: 'hubs.profiles.graduation-rate.1-years',
    defaultMessage: '1 Year',
  },
  months6: {
    id: 'hubs.profiles.graduation-rate.6-months',
    defaultMessage: '6 Months',
  },
  title: {
    id: 'hubs.profiles.graduation-rate.title',
    defaultMessage: 'Job Placement Rate',
  },
  description: {
    id: 'hubs.profiles.graduation-rate.description',
    defaultMessage: 'Students who find employment after graduation',
  },
  within: {
    id: 'hubs.profiles.graduation-rate.within',
    defaultMessage: 'Within',
  },
});

function JobPlacementRate({ lessThan1Year, lessThan6Months, intl, lastUpdated }) {
  const values = [
    lessThan6Months
      ? { label: intl.formatMessage(messages.months6), value: lessThan6Months }
      : false,
    lessThan1Year
      ? { label: intl.formatMessage(messages.years1), value: lessThan1Year }
      : false,
  ].filter(i => i);

  return lessThan6Months || lessThan1Year ? (
    <PercentageDataPod
      header={intl.formatMessage(messages.title)}
      footer={lastUpdated}
      isToggle
      content={{
        values,
        type: 'purple',
        text: intl.formatMessage(messages.description),
        subtitle: intl.formatMessage(messages.within),
      }}
    />
  ) : null;
}

export default injectIntl(JobPlacementRate);

JobPlacementRate.propTypes = {
  lessThan1Year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lessThan6Months: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  intl: PropTypes.object,
  lastUpdated: PropTypes.string,
};
